<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <!-- <List-user v-show="list" ref="list_user" />
    <List-admin v-show="list" ref="list_admin" /> -->
    <List-partner v-show="list" ref="list_partner" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
// import ListUser from './Action.List.User';
// import ListAdmin from './Action.List.Admin';
import ListPartner from './Action.List.Partner';
import Detail from './Action.Detail';

export default {
  components: { ListPartner, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list_user.refresh(); this.$refs.list_admin.refresh(); this.$refs.list_partner.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('log_Action.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created: function() { console.log('log_Action.vue', 'created'); },
  destroyed: function() { console.log('log_Action.vue', 'destroyed'); },
  mounted: function() {
    console.log('log_Action.vue', 'mounted');
    this.select(this.$route.params);
  },
}
</script>
